<template>
    <!--https://www.svgrepo.com/svg/425200/message-chat-essential-->
    <!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
    <svg
        fill="#000000"
        width="20px"
        height="20px"
        viewBox="0 0 32 32"
        style="fill-rule: evenodd; clip-rule: evenodd; stroke-linejoin: round; stroke-miterlimit: 2"
        version="1.1"
        xml:space="preserve"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <g transform="matrix(1,0,0,1,-384,0)">
            <g transform="matrix(1.03846,0,0,1.03846,33.9615,-0.115385)">
                <path
                    d="M341.801,21.963C340.658,20.076 340,17.864 340,15.5C340,8.601 345.601,3 352.5,3C359.399,3 365,8.601 365,15.5C365,22.399 359.399,28 352.5,28C350.676,28 348.943,27.608 347.38,26.905L340,28L341.801,21.963Z"
                    style="fill: rgb(144, 224, 239)"
                />
            </g>

            <path
                d="M387.826,22.822L386.08,28.676C385.982,29.003 386.059,29.358 386.283,29.616C386.507,29.875 386.847,30.001 387.185,29.951L394.565,28.856C396.24,29.567 398.084,29.962 400.019,29.962C407.735,29.962 414,23.697 414,15.981C414,8.265 407.735,2 400.019,2C392.303,2 386.038,8.265 386.038,15.981C386.038,18.465 386.688,20.799 387.826,22.822ZM389.867,22.978C389.947,22.708 389.91,22.416 389.764,22.174C388.669,20.366 388.038,18.246 388.038,15.981C388.038,9.368 393.407,4 400.019,4C406.632,4 412,9.368 412,15.981C412,22.593 406.632,27.962 400.019,27.962C398.271,27.962 396.61,27.587 395.113,26.913C394.938,26.834 394.745,26.807 394.555,26.835L388.446,27.742C388.446,27.742 389.867,22.978 389.867,22.978ZM393,20L401,20C401.552,20 402,19.552 402,19C402,18.448 401.552,18 401,18L393,18C392.448,18 392,18.448 392,19C392,19.552 392.448,20 393,20ZM393,14L407,14C407.552,14 408,13.552 408,13C408,12.448 407.552,12 407,12L393,12C392.448,12 392,12.448 392,13C392,13.552 392.448,14 393,14Z"
                style="fill: rgb(25, 144, 167)"
            />
        </g>
    </svg>
</template>
<script>
export default {
    name: "DmIcon",
};
</script>
